import { render, staticRenderFns } from "./InsuranceBankingDetails.vue?vue&type=template&id=024b89cc&scoped=true"
import script from "./InsuranceBankingDetails.vue?vue&type=script&lang=js"
export * from "./InsuranceBankingDetails.vue?vue&type=script&lang=js"
import style0 from "./InsuranceBankingDetails.vue?vue&type=style&index=0&id=024b89cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b89cc",
  null
  
)

export default component.exports